export default __webpack_public_path__ + "static/media/onetreeplanted_logo.9bae8357.jpg";